exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.self-apply-modal .modal-dialog{width:450px}}@media (max-width:768px){.self-apply-modal .modal-dialog{width:280px;top:20%;left:5%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/applications/apply/SelfApplyModal.css
// module id = 1066
// module chunks = 0